
import { catchError, map } from 'rxjs/operators';
import { HttpService } from '../services/http.service';
import { LocalStorageService } from '../services/local_storage.service';
import { BaseModel } from '../models/base';
// import { Response } from '@angular/http';
import { WaitpromiseService } from '../services/waitpromise.service';
import { Observable, ReplaySubject, isObservable, throwError as observableThrowError } from 'rxjs';


import { environment } from '../../../environments/environment';

export class BaseProvider {

    constructor(
        protected http: HttpService,
        protected path,
        public local: LocalStorageService,
        public waitProm: WaitpromiseService
    ) { }

    checkSession(login) {
        return this.http.checkSession(login).pipe(map((response) => {
            // return response.json();
            return response;
        }), catchError((error) => this.handleServerError(error)),)
            .toPromise();
    }

    checkSessionOpenId(url, data: any) {
        const newEntity: any = this.replaceEntityObjects(data);
        return this.http.checkSessionOpenId(`${url}`, newEntity).pipe(
            map((response) => {
                console.log();
                const body = response;
                // if (token === 'TOKEN_INVALID') {
                //     throw new Error(`ERREURSERVEUR TOKEN_INVALID`);
                // } else {
                //     localStorage.setItem('token', token);
                // }

                if (body.message && !body.continueProcess && body.message !== null) {
                    throw new Error(`ERREURSERVEUR ${body.message}`);
                } else {
                    if (body.continueProcess) {
                        const message = body.message;
                        body.messageAfficher = body.message;
                        body.message = null; // Pour eviter les conditions avec body.message !== '' car on doit continuer l'exécution du code
                        console.error(`ERREURSERVEUR ${message}  finError`);
                    }
                    return body || {};
                }
            }),
            catchError((error) => this.handleServerError(error)),)
            .toPromise();
    }

    logout(): Promise<any> {
        return this.http.logout().pipe(map((response) => {
        }), catchError((error) => this.handleServerError(error)),)
            .toPromise();
    }

    logoutHolding(): Promise<any> {
        return this.http.logoutHolding().pipe(map((response) => {
        }), catchError((error) => this.handleServerError(error)),)
            .toPromise();
    }

    searchEcoloc(data: any) {
        if (data.type && data.type.indexOf('clients')) {
            data.afficherPrenom = 'true';
            data.afficherVilleClient = 'true';
        }
        if (data['param'].type && (data['param'].type.indexOf('clients') || data['param'].type.includes('clients'))) {
            data['param'].afficherPrenom = 'true';
            data['param'].afficherVilleClient = 'true';
        }

        const newEntity: any = this.replaceEntityObjects(data);
        this.setIdRequeteEncours();
        return this.http.searchEcoloc(newEntity).pipe(
            map((response) => {
                // const body = response.json();
                const body = response;
                if (body.message && !body.continueProcess && body.message !== null) {
                    throw new Error(`ERREURSERVEUR ${body.message}`);
                } else {
                    if (body.continueProcess) {
                        const message = body.message;
                        body.messageAfficher = body.message;
                        body.message = null; // Pour eviter les conditions avec body.message !== '' car on doit continuer l'exécution du code
                        console.error(`ERREURSERVEUR ${message}  finError`);
                    }
                    if (data && data.param && (data.param.servlet === 'DBGetListeExuLimites')) {
                        this.doAnothetThing(body || [], true);
                    } else {
                        this.doAnothetThing(body || []);
                    }
                    return body || [];
                }
            }),
            catchError((error) => this.handleServerError(error)),)
            .toPromise();
    }

    post(path, data: any, hasSpinner?, pasMessage?): Promise<any> {
        const newEntity: any = this.replaceEntityObjects(data);
        if (hasSpinner) {
            this.local.set('hasSpinner', 'true');
        }
        this.setIdRequeteEncours();
        return this.http.post(`${path}`, newEntity).pipe(
            map((response) => {
                // this.decompressData(response);
                // const body = response.json();
                const body = response;
                // return just the response, or an empty array if there's no data
                if (body.message && !body.continueProcess && body.message !== null) {
                    if (!pasMessage) {
                        throw new Error(`ERREURSERVEUR ${body.message}`);
                    } else {
                        return body || [];
                    }

                } else {
                    if (body.continueProcess) {
                        const message = body.message;
                        body.messageAfficher = body.message;
                        body.message = null; // Pour eviter les conditions avec body.message !== '' car on doit continuer l'exécution du code
                        console.error(`ERREURSERVEUR ${message}  finError`);
                    }
                    if (hasSpinner) {
                        this.local.remove('hasSpinner');
                    }
                    if (data && data.param && (data.param.servlet === 'DBGetListeExuLimites')) {
                        this.doAnothetThing(body || [], true);
                    } else {
                        this.doAnothetThing(body || []);
                    }
                    return body || [];
                }

                // return response.json() || [];
            }),
            catchError((error) => this.handleServerError(error)),)
            .toPromise();
    }

    postSansErreur(path, data: any, hasSpinner?): Promise<any> {
        const newEntity: any = this.replaceEntityObjects(data);
        if (hasSpinner) {
            this.local.set('hasSpinner', 'true');
        }

        return this.http.post(`${path}`, newEntity).pipe(
            map((response) => {
                const body = response;
                if (hasSpinner) {
                    this.local.remove('hasSpinner');
                }
                if (data && data.param && (data.param.servlet === 'DBGetListeExuLimites')) {
                    this.doAnothetThing(body || [], true);
                } else {
                    this.doAnothetThing(body || []);
                }
                return body || [];
            }))
            .toPromise();
    }

    postHolding(path, data: any, hasSpinner?): Promise<any> {
        const newEntity: any = this.replaceEntityObjects(data);
        if (hasSpinner) {
            this.local.set('hasSpinner', 'true');
        }
        this.setIdRequeteEncours();
        return this.http.postHolding(`${path}`, newEntity).pipe(
            map((response) => {
                // this.decompressData(response);
                // const body = response.json();
                const body = response;
                // return just the response, or an empty array if there's no data
                if (body.message && !body.continueProcess && body.message !== null) {
                    throw new Error(`ERREURSERVEUR ${body.message}`);
                } else {
                    if (body.continueProcess) {
                        const message = body.message;
                        body.messageAfficher = body.message;
                        body.message = null; // Pour eviter les conditions avec body.message !== '' car on doit continuer l'exécution du code
                        console.error(`ERREURSERVEUR ${message}  finError`);
                    }
                    if (hasSpinner) {
                        this.local.remove('hasSpinner');
                    }
                    if (data && data.param && (data.param.servlet === 'DBGetListeExuLimites')) {
                        this.doAnothetThing(body || [], true);
                    } else {
                        this.doAnothetThing(body || []);
                    }
                    return body || [];
                }

                // return response.json() || [];
            }),
            catchError((error) => this.handleServerError(error)),)
            .toPromise();
    }

    postHoldingAutre(path, data: any, hasSpinner?): Promise<any> {
        const newEntity: any = this.replaceEntityObjects(data);
        if (hasSpinner) {
            this.local.set('hasSpinner', 'true');
        }
        this.setIdRequeteEncours();
        return this.http.postHoldingAutre(`${path}`, newEntity).pipe(
            map((response) => {
                // this.decompressData(response);
                // const body = response.json();
                const body = response;
                // return just the response, or an empty array if there's no data
                if (body.message && !body.continueProcess && body.message !== null) {
                    throw new Error(`ERREURSERVEUR ${body.message}`);
                } else {
                    if (body.continueProcess) {
                        const message = body.message;
                        body.messageAfficher = body.message;
                        body.message = null; // Pour eviter les conditions avec body.message !== '' car on doit continuer l'exécution du code
                        console.error(`ERREURSERVEUR ${message}  finError`);
                    }
                    if (hasSpinner) {
                        this.local.remove('hasSpinner');
                    }
                    if (data && data.param && (data.param.servlet === 'DBGetListeExuLimites')) {
                        this.doAnothetThing(body || [], true);
                    } else {
                        this.doAnothetThing(body || []);
                    }
                    return body || [];
                }

                // return response.json() || [];
            }),
            catchError((error) => this.handleServerError(error)),)
            .toPromise();
    }

    postSub(path, data: any, hasSpinner?, pasMsg?) {
        const newEntity: any = this.replaceEntityObjects(data);
        if (hasSpinner) {
            this.local.set('hasSpinner', 'true');
        }
        this.setIdRequeteEncours();
        return this.http.post(`${path}`, newEntity).pipe(
            map((response) => {
                // const body = response.json();
                const body = response;
                if (body.message && !body.continueProcess && body.message !== null) {
                    if (!pasMsg) {
                        throw new Error(`ERREURSERVEUR ${body.message}`);
                    } else {
                        return body || [];
                    }

                } else {
                    if (body.continueProcess) {
                        const message = body.message;
                        body.messageAfficher = body.message;
                        body.message = null; // Pour eviter les conditions avec body.message !== '' car on doit continuer l'exécution du code
                        console.error(`ERREURSERVEUR ${message}  finError`);
                    }
                    if (hasSpinner) {
                        this.local.remove('hasSpinner');
                    }
                    if (data && data.param && (data.param.servlet === 'DBGetListeExuLimites')) {
                        this.doAnothetThing(body || [], true);
                    } else {
                        this.doAnothetThing(body || []);
                    }
                    return body || [];
                }
            }));
    }

    get(path?, hasSpinner?, isBool?): Promise<any> {
        if (hasSpinner) {
            this.local.set('hasSpinner', 'true');
        }
        this.setIdRequeteEncours();
        return this.http.getMethode(path).pipe(
            map((response) => {
                // const body = response.json();
                console.log(response)
                const body = response;
                if (body.message && !body.continueProcess && body.message !== null) {
                    throw new Error(`ERREURSERVEUR ${body.message}`);
                } else {
                    if (body.continueProcess) {
                        const message = body.message;
                        body.messageAfficher = body.message;
                        body.message = null; // Pour eviter les conditions avec body.message !== '' car on doit continuer l'exécution du code
                        console.error(`ERREURSERVEUR ${message}  finError`);
                    }
                    if (hasSpinner) {
                        this.local.remove('hasSpinner');
                    }
                    this.doAnothetThing(body);
                    return isBool ? body : (body || []);
                }
            }), catchError((error) => this.handleServerError(error, path)),)
            .toPromise();
    }

    getFileEcorec(path?): Promise<any> {
        return this.http.get(path).pipe(
            map((response) => {
                // const body = response.json();
                const a = document.createElement('a');
                a.href = URL.createObjectURL(response.blob());
                a.download = 'Fiche de contrôle';
                // start download
                a.click();
            }), catchError((error) => this.handleServerError(error, path)),)
            .toPromise();
    }


    postEcoportail(path, data: any, isString?, appelDepuisEcorec?, hasSpinner?, pasDeReponse?): Promise<any> {
        let newEntity: any = this.replaceEntityObjects(data);
        if (path === 'user/login') {
            // newEntity = newEntity.replace(/"/g, '');
        }
        if (hasSpinner) {
            this.local.set('hasSpinner', 'true');
        }
        return this.http.postEcoportail(`${path}`, newEntity, (appelDepuisEcorec ? true : false)).pipe(
            map((response) => {
                if (pasDeReponse) {
                    return response
                }
                if (!isString) {
                    // const result = response.json();
                    const result = response;
                    // console.log(result)
                    if (typeof result === 'object') {
                        if (Array.isArray(result)) {
                            if (result.length) {
                                if (!result[0].errorId && !result[0].error) {
                                    return result;
                                }
                                throw new Error(environment.moduleEcoportailOnly ? `${result[0].errorId} ERREURSERVEUR ${result[0].error}.`
                                    : `ERREURSERVEUR ${result[0].error}`);
                            } else {
                                if (hasSpinner) {
                                    this.local.remove('hasSpinner');
                                }
                                return result;
                            }
                        } else {
                            if (result && !result.errorId && !result.error) {
                                if (hasSpinner) {
                                    this.local.remove('hasSpinner');
                                }
                                return result;
                            }
                            throw new Error(`${result ? result.errorId : ''} ERREURSERVEUR ${result ? result.error : 'null'}.`);
                        }
                    }
                } else {
                    return response.text();
                }
            }), catchError((error) => this.handleServerError(error, path)),)
            .toPromise();
    }

    postEcoportailPasError(path, data: any, isString?, appelDepuisEcorec?, hasSpinner?): Promise<any> {
        let newEntity: any = this.replaceEntityObjects(data);
        if (path === 'user/login') {
            // newEntity = newEntity.replace(/"/g, '');
        }
        if (hasSpinner) {
            this.local.set('hasSpinner', 'true');
        }
        return this.http.postEcoportail(`${path}`, newEntity, (appelDepuisEcorec ? true : false)).pipe(
            map((response) => {
                if (!isString) {
                    // const result = response.json();
                    const result = response;
                    // console.log(result)
                    if (typeof result === 'object') {
                        if (hasSpinner) {
                            this.local.remove('hasSpinner');
                        }
                        return result;
                    }
                } else {
                    if (hasSpinner) {
                        this.local.remove('hasSpinner');
                    }
                    return response.text();
                }
            }), catchError((error) => this.handleServerError(error, path)),)
            .toPromise();
    }

    getEcoportail(path, appelDepuisEcorec?, hasSpinner?) {
        if (hasSpinner) {
            this.local.set('hasSpinner', 'true');
        }
        return this.http.getEcoportail(path, (appelDepuisEcorec ? true : false)).pipe(map((response) => {
            let data;
            // data = response.json();
            data = response;
            const result: any[] = [];
            if (data instanceof Array) {
                for (const i in data) {
                    result.push(data[i]);
                }
            } else if (data != null) {
                result.push(data);
            }
            if (result.length) {
                if (!result[0].errorId && !result[0].error) {
                    if (hasSpinner) {
                        this.local.remove('hasSpinner');
                    }
                    return result;
                }
                throw new Error(`${result[0].errorId} ERREURSERVEUR ${result[0].error}`);
            } else {
                if (hasSpinner) {
                    this.local.remove('hasSpinner');
                }

                return result;
            }

        }), catchError((error) => this.handleServerError(error, path)),)
            .toPromise();
    }

    putEcoportail(path, appelDepuisEcorec?, hasSpinner?) {
        if (hasSpinner) {
            this.local.set('hasSpinner', 'true');
        }
        return this.http.putEcoportail(path, (appelDepuisEcorec ? true : false)).pipe(map((response) => {
            let data;
            // data = response.json();
            data = response;
            const result: any[] = [];
            if (data instanceof Array) {
                for (const i in data) {
                    result.push(data[i]);
                }
            } else if (data != null) {
                result.push(data);
            }
            if (result.length) {
                if (!result[0].errorId && !result[0].error) {
                    if (hasSpinner) {
                        this.local.remove('hasSpinner');
                    }
                    return result;
                }
                throw new Error(`${result[0].errorId} ERREURSERVEUR ${result[0].error}`);
            } else {
                if (hasSpinner) {
                    this.local.remove('hasSpinner');
                }

                return result;
            }

        }), catchError((error) => this.handleServerError(error, path)),)
            .toPromise();
    }

    getdocumentEcoportail(path, isString?, hasSpinner?) {
        if (hasSpinner) {
            this.local.set('hasSpinner', 'true');
        }
        return this.http.getEcoportail(path).pipe(map((response) => {
            let data;
            if (!isString) {
                // data = response.json();
                data = response;
                const result: any[] = [];
                if (data instanceof Array) {
                    for (const i in data) {
                        result.push(data[i]);
                    }
                } else if (data != null) {
                    result.push(data);
                }
                if (result.length) {
                    if (!result[0].errorId && !result[0].error) {
                        if (hasSpinner) {
                            this.local.remove('hasSpinner');
                        }
                        return result;
                    }
                    throw new Error(`${result[0].errorId} ERREURSERVEUR ${result[0].error}.`);
                } else {
                    if (hasSpinner) {
                        this.local.remove('hasSpinner');
                    }
                    return result;
                }
            } else {
                return response.text();
            }

        })).toPromise();
    }

    getFileEcoportail(path) {
        return this.http.getEcoportailFile(path).pipe(map((response) => {
            const data = response;
            /*const result: any[] = [];
            if (data instanceof Array) {
                for (const i in data) {
                    result.push(data[i]);
                }
            } else if (data != null) {
                result.push(data);
            }
            if (result.length) {
                if (!result[0].errorId && !result[0].error) {
                    return result;
                }
                throw new Error(` ${result[0].error}.`);
            } else {
                return result;
            }*/
            return data;
        }))
            .toPromise();
    }

    // getRssFlux(url) {
    //     return this.http.getRss(url).pipe(map((response) => {
    //         // const feed = response.json();
    //         const feed = response;
    //         return feed || {};
    //     })).toPromise();
    // }

    getUrlPortailPaiement(url) {
        return this.http.getUrlPortail(url);
    }

    getHtml(url) {
        return this.http.getHtml(url).pipe(map((response) => {
            // const feed = response.json();
            const feed = response;
            return feed || {};
        })).toPromise();
    }

    getFile(url) {
        return this.http.getHtml(url).pipe(map((response) => {
            return response;
            // return response.json();
        })).toPromise();
    }

    // protected handleServerError(error: Response): Observable<Response> {
    protected handleServerError(error, path?) {
        let erreur = '';
        this.local.remove('hasSpinner');
        console.log('test', error)
        if (!environment.moduleEcoportailOnly) {
            this.doAnothetThing([]);
            if (error.status === 403) {
                console.info('403: forbidden');
                erreur = ('ERREURSERVEUR ' + (error['message'] || 'Server error: 403: forbidden') + 'finError');
                // TODO
            }
            if (error.status === 404) {
                console.info('404: not found');
                const message = error.error && error.error['message'] ? error.error['message'] : error['message'];
                erreur = ('ERREURSERVEUR ' + (message || 'Server error: 404: not found') + 'finError');
                // TODO
            }
            if (error.status === 413) {
                console.info('404: not found');
                erreur = ('ERREURSERVEUR ' + (error['message'] || 'Server error: 413: Request Entity Too Large') + 'finError');
                // TODO
            }
            if (error.status === 502) {
                console.info('502: not found');
                erreur = ('ERREURSERVEUR ' + (error['message'] || 'Server error: bad getway') + 'finError');
                // TODO
            } else {
                if (error.status === 0) {
                    console.info('ERR_CONNECTION_TIMED_OUT');
                    erreur = ('ERREURSERVEUR ERR_CONNECTION_TIMED_OUT finError');
                    // TODO
                } else {
                    if (error.status === 200) {
                        console.log(error['error'].text)
                        const err = error['error'] ? (typeof error['error'].text !== 'object' ?
                            error['error'].text : (error['error'].text || '').json()) : '';

                        erreur = ('ERREURSERVEUR ' + (err['message'] || '') + 'finError');
                        // TODO
                    } else {
                        if (error['error'] && (error['error'].message)) {
                            erreur = ('ERREURSERVEUR ' + (error['error'].message || '') + 'finError');
                        } else {
                            erreur = ((error || 'Server error') + 'finError');
                        }

                    }
                }
            }
            console.error(erreur);
            return observableThrowError(erreur);
        } else {
            if (error.status === 403) {
                erreur = ('ERREURSERVEUR ' + (path || '') + (error['message'] || 'Server error: 403: forbidden') + 'finError');
                // TODO
            }
            if (error.status === 404) {
                const message = error.error && error.error['message'] ? error.error['message'] : error['message'];
                erreur = ('ERREURSERVEUR ' + (path || '') + (message || 'Server error: 404: not found') + 'finError');
                // TODO
            }
            if (error.status === 413) {

                erreur = ('ERREURSERVEUR ' + (path || '') + (error['message'] || 'Server error: 413: Request Entity Too Large') + 'finError');
                // TODO
            }
            if (error.status === 502) {
                erreur = ('ERREURSERVEUR ' + (path || '') + (error['message'] || 'Server error: bad getway') + 'finError');
                // TODO
            } else {
                if (error.status === 0) {
                    erreur = ('ERREURSERVEUR ERR_CONNECTION_TIMED_OUT finError');
                    // TODO
                } else {
                    if (error.status === 200) {
                        console.log(error['error'].text)
                        const err = error['error'] ? (typeof error['error'].text !== 'object' ?
                            error['error'].text : (error['error'].text || '').json()) : '';

                        erreur = ('ERREURSERVEUR ' + (err['message'] || '') + 'finError');
                        // TODO
                    } else {

                        if (error['error'] && (error['error'].message)) {
                            erreur = ('ERREURSERVEUR ' + (error['error'].message || '') + 'finError');
                        } else {
                            erreur = ((error || 'Server error') + 'finError');
                        }
                    }
                }
            }
            console.error(erreur);
            return observableThrowError(error);
        }
    }

    protected replaceEntityObjects(entity: any): any {
        const newEntity: any = entity;
        this.getRequeteComboK3(entity);
        let param = '';
        const keys = Object.keys(newEntity);
        for (let i in keys) {
            let property = keys[i];
            if (newEntity[property] && ((typeof newEntity[property]) === 'object')) {
                const value = JSON.stringify(newEntity[property]);
                const replace = value.split('%').join('\\u0025');
                const valeur = replace.split('&').join('\\u0026');
                const lastval = valeur.split('+').join('\\u002B');
                param += !param.length ? `${property}=${lastval}` : `&${property}=${lastval}`;
            } else {
                const value = JSON.stringify(newEntity[property]);
                const replace = value.split('%').join('\\u0025');
                const valeur = replace.split('&').join('\\u0026');
                const lastval = valeur.split('+').join('\\u002B');
                param += !param.length ? `${property}=${lastval}` : `&${property}=${lastval}`;
            }
        }
        return param;
    }


    // parse json to map key
    protected parseData(data) {
        const list = JSON.parse(data);
        const output = {};

        for (let i = 0; i < list.length; i++) {
            for (const key in list[i]) {
                if (list[i].hasOwnProperty(key)) {
                    if (typeof output[key] === 'undefined') {
                        output[key] = [];
                    }
                    output[key].push(list[i][key]);
                }
            }
        }
        return output;
    }

    getEcomobile(path) {
        return this.http.getEcomobile(path).pipe(map((response) => {
            // const data = response.json();
            const data = response;
            const result: any[] = [];
            if (data instanceof Array) {
                for (const i in data) {
                    result.push(data[i]);
                }
            } else if (data != null) {
                result.push(data);
            }
            if (result.length) {
                if (!result[0].errorId && !result[0].error) {
                    return result;
                }
                throw new Error(`${result[0].errorId} ERREURSERVEUR ${result[0].error}.`);
            } else {
                return result;
            }
        }))
            .toPromise();
    }

    postEcomobile(path, data: any): Promise<any> {
        let newEntity: any = this.replaceEntityObjects(data);
        newEntity = newEntity.replace(/"/g, '');
        return this.http.postEcomobile(`${path}`, newEntity).pipe(
            map((response) => {
                // const result = response.json();
                const result = response;
                if (typeof result === 'object') {
                    if (Array.isArray(result)) {
                        if (result.length) {
                            if (!result[0].errorId && !result[0].error) {
                                return result;
                            }
                            throw new Error(`${result[0].errorId} ERREURSERVEUR ${result[0].error}.`);
                        } else {
                            return result;
                        }
                    } else {
                        if (!result.errorId && !result.error) {
                            return result;
                        }
                        throw new Error(`${result.errorId} ERREURSERVEUR ${result.error}.`);
                    }
                }
            }), catchError((error) => this.handleServerError(error, path)),)
            .toPromise();
    }

    getURL(path, message?, hasSpinner?) {
        if (hasSpinner) {
            this.local.set('hasSpinner', 'true');
        }
        return this.http.getURL(path).pipe(map((response) => {
            // const data = response.json();
            this.local.remove('hasSpinner');
            const data = response;
            const result: any[] = [];
            if (data instanceof Array) {
                for (const i in data) {
                    result.push(data[i]);
                }
            } else if (data != null) {
                result.push(data);
            }
            if (result.length) {
                if (message) {
                    if (!result[0].errorId && !result[0].error) {
                        return result;
                    }
                    this.local.remove('hasSpinner');
                    throw new Error(`${result[0].errorId} ERREURSERVEUR ${result[0].error}.`);
                } else {
                    if (!result[0].errorId && !result[0].error && !result[0].message) {
                        return result;
                    }
                    this.local.remove('hasSpinner');
                    throw new Error(`${result[0].errorId} ERREURSERVEUR ${result[0].error || result[0].message}.`);
                }
            } else {
                return result;
            }
        }), catchError((error) => this.handleServerError(error, path)))
            .toPromise();
    }

    postURL(path, data: any, hasSpinner?): Promise<any> {
        const newEntity: any = this.replaceEntityObjects(data);
        if (hasSpinner) {
            this.local.set('hasSpinner', 'true');
        }
        return this.http.postURL(`${path}`, newEntity).pipe(
            map((response) => {
                // const result = response.json();
                this.local.remove('hasSpinner');
                const result = response;
                if (typeof result === 'object') {
                    if (Array.isArray(result)) {
                        if (result.length) {
                            if (!result[0].errorId && !result[0].error && !result[0].message) {
                                return result;
                            }
                            this.local.remove('hasSpinner');
                            throw new Error(`${result[0].errorId} ERREURSERVEUR  ${result[0].error || result[0].message}.`);
                        } else {
                            return result;
                        }
                    } else {
                        if (!result.errorId && !result.error) {
                            return result;
                        }
                        this.local.remove('hasSpinner');
                        throw new Error(`${result.errorId} ERREURSERVEUR ${result.error}.`);
                    }
                }
            }), catchError((error) => this.handleServerError(error, path)),)
            .toPromise();
    }

    postURLLibradata(path, data: any): Promise<any> {
        let newEntity: any = this.replaceEntityObjects(data);
        newEntity = newEntity.replace(/"/g, '');
        return this.http.postURL(`${path}`, newEntity).pipe(
            map((response) => {
                // const result = response.json();
                console.log(response)
            }), catchError((error) => this.handleServerError(error)),)
            .toPromise();
    }

    postURLForm(path, data: any, hasSpinner?): Promise<any> {
        if (hasSpinner) {
            this.local.set('hasSpinner', 'true');
        }
        const newEntity: any = this.replaceEntityObjects(data);
        return this.http.postURL(`${path}`, data, true).pipe(
            map((response) => {
                // const result = response.json();
                const result = response;
                if (hasSpinner) {
                    this.local.remove('hasSpinner');
                }
                if (typeof result === 'object') {
                    if (Array.isArray(result)) {
                        if (result.length) {
                            if (!result[0].errorId && !result[0].error) {
                                return result;
                            }
                            throw new Error(`${result[0].errorId} ERREURSERVEUR  ${result[0].error}.`);
                        } else {
                            return result;
                        }
                    } else {
                        if (!result.errorId && !result.error) {
                            return result;
                        }
                        throw new Error(`${result.errorId} ERREURSERVEUR ${result.error}.`);
                    }
                }
            }), catchError((error) => this.handleServerError(error)),)
            .toPromise();
    }

    postURLNotForm(path, data: any, hasSpinner?): Promise<any> {
        const newEntity: any = this.replaceEntityObjects(data);
        if (hasSpinner) {
            this.local.set('hasSpinner', 'true');
        }
        this.setIdRequeteEncours();
        return this.http.postURLNotForm(`${path}`, newEntity, false).pipe(
            map((response) => {
                const result = response;
                if (hasSpinner) {
                    this.local.remove('hasSpinner');
                }
                if (typeof result === 'object') {
                    if (Array.isArray(result)) {
                        if (result.length) {
                            if (!result[0].errorId && !result[0].error) {
                                return result;
                            }
                            throw new Error(`${result[0].errorId} ERREURSERVEUR  ${result[0].error}.`);
                        } else {
                            return result;
                        }
                    } else {
                        if (!result.errorId && !result.error) {
                            return result;
                        }
                        throw new Error(`${result.errorId} ERREURSERVEUR ${result.error}.`);
                    }
                }
            }),
            catchError((error) => this.handleServerError(error)),)
            .toPromise();
    }

    getUrlEcoportail(url?) {
        return this.http.buildUrlEcoPortail(url || '');
    }

    postURLFormEcoPortail(path, data: any, hasSpinner?): Promise<any> {
        if (hasSpinner) {
            this.local.set('hasSpinner', 'true');
        }
        const urlecoportail = this.http.buildUrlEcoPortail(path);
        const newEntity: any = this.replaceEntityObjects(data);
        return this.http.postURL(`${urlecoportail}`, data, true).pipe(
            map((response) => {
                // const result = response.json();
                const result = response;
                if (typeof result === 'object') {
                    if (Array.isArray(result)) {
                        if (result.length) {
                            if (!result[0].errorId && !result[0].error) {
                                if (hasSpinner) {
                                    this.local.remove('hasSpinner');
                                }
                                return result;
                            }
                            if (hasSpinner) {
                                this.local.remove('hasSpinner');
                            }
                            throw new Error(`${result[0].errorId} ERREURSERVEUR  ${result[0].error}.`);
                        } else {
                            if (hasSpinner) {
                                this.local.remove('hasSpinner');
                            }
                            return result;
                        }
                    } else {
                        if (!result.errorId && !result.error) {
                            if (hasSpinner) {
                                this.local.remove('hasSpinner');
                            }
                            return result;
                        }
                        if (hasSpinner) {
                            this.local.remove('hasSpinner');
                        }
                        throw new Error(`${result.errorId} ERREURSERVEUR ${result.error}.`);
                    }
                }
            }), catchError((error) => this.handleServerError(error)),)
            .toPromise();
    }

    postPaiement(url, data: any) {
        const newEntity: any = this.replaceEntityObjects(data);
        return this.http.postPaiement(url, newEntity).pipe(map((response) => {
            const htmlPage = response.text;
            return htmlPage || '';
        })).toPromise();
    }

    /*decompressData(compressData) {
        // const decompressResponse = require('decompress-response');
        // console.log(decompressResponse(compressData));
        const zlib = require('zlib');
        // const inflate = zlib.Inflate(compressData);
        var inflate = new zlib.Inflate(compressData);
        // var output = inflate.decompress();
        // const output = zlib.inflate(compressData);
        console.log(inflate);
        // return output;
    }*/

    getRequeteComboK3(data) {
        const param = data['param'] || {};
        if (param['servlet'] === 'DBGetListComboK3') {
            const datas = param['data'] || [];
            if (datas.length) {
                datas[1] = btoa(datas[1]);
            }
            console.log('DBGetListComboK3', param);
        }
    }

    doAnothetThing(data, isSearchExutoire?) {
        if (this.local.get('numautocomplete') && !isSearchExutoire) {
            if (this.waitProm.doSomething[this.local.get('numautocomplete')]) {
                this.waitProm.doSomething[this.local.get('numautocomplete')].next(data);
            }
        }
    }

    setIdRequeteEncours() {
        if (this.local.get('numautocomplete')) {
            this.local.set('IdRequeteEncours', this.local.get('numautocomplete'));
        }
    }

}
